"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectionType = void 0;
var RejectionType;
(function (RejectionType) {
    RejectionType["ValidationError"] = "Validation error";
    RejectionType["UserUnauthorized"] = "User unauthorized";
    RejectionType["Forbidden"] = "Forbidden";
    RejectionType["NotFound"] = "Not found";
    RejectionType["CantProvideOperation"] = "Can't update, delete, cancel, confirm or accept";
    RejectionType["AlreadyExists"] = "Already exists";
    RejectionType["InvalidVersion"] = "Object you tried to save was changed by someone else meanwhile, please back up your work and reload this page to be able to reapply your changes";
    RejectionType["NoTravelDataFromGoogle"] = "No travel data evaluated from google";
    RejectionType["UnableToCalculateDistanceOrDuration"] = "Unable to calculate distance or duration";
    RejectionType["PersonalIdNotTwoFiles"] = "Personal id does not have two files.";
    RejectionType["UploadFailed"] = "Upload failed";
    RejectionType["AlreadyConnecting"] = "Already connecting";
    RejectionType["NoWallet"] = "No wallet";
    RejectionType["TokensExpired"] = "Tokens expired";
    RejectionType["TokensInvalid"] = "Tokens invalid or expired";
    RejectionType["RefreshTokensExpired"] = "Refresh token expired";
    RejectionType["ModelUsed"] = "Vehicle model used";
    RejectionType["PaymentFailed"] = "Payment failed";
    RejectionType["CreatePaymentError"] = "Create payment error";
    RejectionType["MangopayMainUser"] = "mainUser";
    RejectionType["MangopayTransactionRefusedByBank"] = "MangopayTransactionRefusedByBank";
    RejectionType["MangopayTransactionRefusedAmountLimit"] = "MangopayTransactionRefusedAmountLimit";
    RejectionType["MangopayThreeDSecureUnathorized"] = "MangopayThreeDSecureUnathorized";
    RejectionType["MangopayTransactionRefusedCardLimit"] = "MangopayTransactionRefusedCardLimit";
    RejectionType["MangopayTransactionRefused"] = "MangopayTransactionRefused";
    RejectionType["MangopayInvalidCardNumber"] = "MangopayInvalidCardNumber";
    RejectionType["Exhausted"] = "Exhausted";
    RejectionType["MangopayCardExpired"] = "MangopayCardExpired";
    RejectionType["MangopayTechnicalError"] = "MangopayTechnicalError";
    RejectionType["MangopayThreeDSecureNotAvailable"] = "MangopayThreeDSecureNotAvailable";
    RejectionType["MangopayThreeDSecureAuthNotAvailable"] = "MangopayThreeDSecureAuthNotAvailable";
    RejectionType["MangopayFraudSuspectedByTheBank"] = "MangopayFraudSuspectedByTheBank";
    RejectionType["MangopayTransactionBlockedByFraudPolicy"] = "MangopayTransactionBlockedByFraudPolicy";
    RejectionType["MangopayUnsupportedCountry"] = "MangopayUnsupportedCountry";
    RejectionType["MangopayTransfersFailed"] = "Some transfers failed";
    RejectionType["GoogleCampaignProcessError"] = "GoogleCampaignProcessError";
    RejectionType["VehicleModelNotApproved"] = "This vehicle model is not approved for";
    RejectionType["VehicleModelNotLuxury"] = "This vehicle model is not approved as luxury for";
    RejectionType["HasActiveAssignations"] = "Order has active assignations";
    RejectionType["CanceledOrder"] = "Order was canceled";
    RejectionType["ServerError"] = "Internal server error";
    RejectionType["InvalidUserOperation"] = "Invalid user operation";
    RejectionType["MultipleUsersAssignedToRide"] = "Multiple drivers or companies assigned to one ride";
    RejectionType["AssigningOnlyChildrenToACarIsNotSupported"] = "Assigning only children to a car is not supported";
    RejectionType["TravelAgentNotApproved"] = "Travel agent not approved";
})(RejectionType || (exports.RejectionType = RejectionType = {}));
//# sourceMappingURL=RejectionType.js.map